import { useCallback } from 'react';
import { useCachedResource } from './useCachedResource'; // Adjust import path
import { appConfig } from '@/lib/AppConfig';
import { FeatureTypeService, type FeatureType } from '@/services/FeatureTypeService';

export const useFeatureTypeName = (featureTypeId?: string) => {
  // Memoize the fetch function to preserve the context
  const fetchArea = useCallback(async (areaId: string) => {
    return await FeatureTypeService.getById(areaId);
  }, []);

  const { data, isLoading, error } = useCachedResource<FeatureType>(
    featureTypeId,
    appConfig.resourceTypes.featureType,
    fetchArea
  );

  return { featureTypeName: data?.name || null, isLoading, error };
};